exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".top-marged {\n    margin-top: 200px;\n}\n\n.top-marged-small {\n    margin-top: 2%;\n}\n\nh1 {\n    font-size: 2.5em;\n    margin-bottom: 2%;\n}\n\ninput {\n    font-size: 1.5em !important;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!./app/components/login/login.component.css
// module id = 857
// module chunks = 0